import { ListItem, ListItemIcon, ListItemText } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function Step({ item }) {
    return (
        <ListItem>
            <ListItemIcon>
                <Iconify icon="mdi:circle" />
            </ListItemIcon>
            <ListItemText primary={item} />
        </ListItem>
    )
}
